import type { FaireProductEntity } from "../../entity_types/product";

export const p_ctqfbth8ev: FaireProductEntity = {
  token: "p_ctqfbth8ev",
  type: "product",
  name: "Orangina Carbonated Orange Slim Can 330ml - 4x6pck (Europe)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/9f01aa9a08cb4974393f13c07322b87e5ddc9f9536c173327424e5384378918a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8368ad0a8615a85a1e89437340eec2a0d0b1ab72034b3db5e833326bdb3fd432.jpeg",
  ],
  priceDollars: 2.56,
  description:
    "Refresh with the world-famous citrus soda! Orangina Carbonated Orange Drink comes in a sleek slim can, packed with lightly sparkling bubbles, natural orange flavor, and real citrus pulp. Known for its distinct taste and refreshing fizz, Orangina has been a European favorite for decades.\n\n✅ Authentic Orangina sparkling orange soda\n✅ Made with real orange pulp for natural flavor\n✅ Light carbonation for a crisp, refreshing sip\n✅ Perfect for parties, picnics, or everyday refreshment\n\nWhether you’re a longtime fan or trying it for the first time, Orangina Slim Can is a refreshing citrus drink that delivers a perfect balance of sweetness and tang.\n\n",
  tags: [],
  msrpDollars: 5.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:39.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
